import { Action } from '../../shared/models/action.model';
import { updateAction } from '../../utils/utility';
import actionTypes from '../types/savedDraftTypes';

export const fetchSavedDraft = (payload: any): Action<any> => {
  return updateAction(actionTypes.SAVED_DRAFT, payload);
};
export const updateSaveDraftStatus = (payload: string): Action<any> => updateAction(actionTypes.UPDATE_SAVE_DRAFT_STATUS, payload);
export const updateDraftId = (payload: number): Action<any> => updateAction(actionTypes.UPDATE_DRAFT_ID, payload);

export const deleteDraft =
  (draft: any, onSuccess: any, onError: any)
  : Action<any[]> => {
    return {
      type: actionTypes.DELETE_DRAFT, ...{ draft, onSuccess, onError },
    };
};

export const saveDraftData =
  (requestPayload: any, onSuccess: any, onError: any)
  : Action<any[]> => {
    return {
      type: actionTypes.SUBMIT_DRAFT, ...{ requestPayload, onSuccess, onError },
    };
};

// export const fetchDraftList = (onSuccess?: any): Action<any> => {
//   return {type: actionTypes.FETCH_DRAFTS, ...{onSuccess}};
// };
export const fetchDraftList = (payload: any): Action<any> => {
  return updateAction(actionTypes.FETCH_DRAFT_LIST, payload);
};
export const searchDraftList = (): Action<any> => {
  return updateAction(actionTypes.SEARCH_DRAFT_LIST);
};

export const lockUnlockOrDeleteDraft = (payload: any): Action<any> => {
  return {type: actionTypes.LOCK_UNLOCK_OR_DELETE_DRAFT, ...{...payload} };
};

export const updatedDraftDeleteCounter = (): Action<any> => {
  return {type: actionTypes.DRAFT_DELETE_COUNTER };
};

export const setDraftError = (errorMessage: any): Action<any> =>
  updateAction(actionTypes.SET_DRAFT_ERROR, errorMessage);

export const setDraftLoading = (isLoading: boolean): Action<any> =>
  updateAction(actionTypes.DRAFT_LOADING, isLoading);

export const setDraftResponseStatus = (status: any): Action<any> =>
  updateAction(actionTypes.DRAFT_RESPONSE_STATUS, status);
